<template>
  <div class="app-shell bg-white text-ink">
    <Navbar />
    <Sidenav />
    <main class="app-main">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import Navbar from '@/components/common/Navbar.vue'
import Footer from '@/components/common/Footer.vue'
import Sidenav from '@/components/common/Sidenav.vue'
import api from '@/services/api'
import { isAuthenticated, setAuthUser } from '@/services/auth'

const loadProfile = async () => {
  if (!isAuthenticated()) return
  const payload = new FormData()
  try {
    const { data } = await api.getProfile(payload)
    const user = data?.user || data?.data?.user || data?.data || data?.profile || null
    if (user) setAuthUser(user)
  } catch {
    // ignore profile load failures
  }
}

onMounted(() => {
  loadProfile()
})
</script>

<style>
:global(html, body, #app) {
  height: 100%;
} 
 

a:hover {
  text-decoration: none!important;
}
</style>
